import useOutsideClick from "hooks/click-outside";
import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const DisableAccount: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const modalRef = useOutsideClick(onClose);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
    >
      <div
        ref={modalRef}
        className={`relative bg-white px-6 py-8 rounded-lg shadow-lg w-[90%] sm:w-[375px] transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl text-center text-primaryBlueText font-bold mb-4">
          Account Action
        </h2>
        <span className="text-base text-center text-primaryBlueText flex justify-center  py-4 bordr-linear">
          Are you sure you want to Disable Host Account from your profile?
        </span>
        <div className="flex justify-center gap-2 pt-4">
          <button className="text-base text-center w-[110px] h-[42px] px-4 py-3 text-primaryBlueText rounded-full bg-fade  ">
            Cancel
          </button>
          <button className="text-base text-center w-[121px] h-[42px] text-white rounded-full bg-primaryBlueBg  ">
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisableAccount;
